<script>
	let { class: className = '', ...props } = $props();
</script>

<svg class={className} fill="none" preserveAspectRatio="none" viewBox="0 0 40 38" {...props}>
	<path
		d="M19 36.567v-18h-7v18m-8 0v-12h6v12m17 0v-24h-6v24m8 0v-29m6 29v-29m-8 0 5.503-7 5.497 7m-9 0h-2m11 0h-3m-34 29h38"
		stroke="currentColor"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
